import { apiAxios } from "@/api/axios";
import base from '../config'
let baseURL = base.baseURL

export default {
  //区域-用途选项设置
  setAreaTypeList: (data) => apiAxios('post', baseURL + '/wms.setAreaTypeList', data),
  //区域-用途选项列表
  areaType: (data) => apiAxios('post', baseURL + '/wms.areaType', data),
  //区域-列表
  areaList: (data) => apiAxios('post', baseURL + '/wms.areaList', data),
  //区域-添加区域
  areStore: (data) => apiAxios('post', baseURL + '/wms.areStore', data),
  //区域-修改区域
  areaUpdate: (data) => apiAxios('post', baseURL + '/wms.areaUpdate', data),
  //区域-是否显示
  setAreaShow: (data) => apiAxios('post', baseURL + '/wms.setAreaShow', data),
  //区域-删除区域
  areDelete: (data) => apiAxios('post', baseURL + '/wms.areDelete', data),

  //货架-货架列表
  shelfList: (data) => apiAxios('post', baseURL + '/wms.shelfList', data),
  // 货架-可选货架类型
  shelfTypes: (data) => apiAxios('post', baseURL + '/wms.shelfTypes', data),
  // 货架-添加货架
  shelfStore: (data, config) => apiAxios('post', baseURL + '/wms.shelfStore', data, config || {}),
  // 货架-修改货架
  shelfUpdate: (data) => apiAxios('post', baseURL + '/wms.shelfUpdate', data),
  // 货架-是否显示
  setShelfShow: (data) => apiAxios('post', baseURL + '/wms.setShelfShow', data),
  // 货架-删除货架
  shelfDelete: (data) => apiAxios('post', baseURL + '/wms.shelfDelete', data),

  // 库位-库位管理
  gridList: (data) => apiAxios('post', baseURL + '/wms.gridList', data),
  //库位-库位管理-批量设置库位
  wmsGridSet: (data) => apiAxios('post', baseURL + '/wms.wmsGridSet', data),
  // 库位-库位属性保存
  gridAttrSave: (data) => apiAxios('post', baseURL + '/wms.gridAttrSave', data),
  // 库位-某一层库位属性详情
  gridFloorDetail: (data) => apiAxios('post', baseURL + '/wms.gridFloorDetail', data),
  // 库位-库位管理-批量删除库位
  wmsGridBatchDelete: (data) => apiAxios('post', baseURL + '/wms.wmsGridBatchDelete', data),
  // 库位-库位管理-库位唛头查询
  gridMarks: (data) => apiAxios('post', baseURL + '/wms.gridMarks', data),



  // 库存-库存列表-(常规,辅料,备品)
  stockList: (data) => apiAxios('post', baseURL + '/wms.stock.stockList', data),
  // 库存-库存列表-(收费仓库按箱子汇总展示)
  stockListCharge: (data) => apiAxios('post', baseURL + '/wms.stock.stockListCharge', data),

  // 库存-废弃申请
  toDiscardApply: (data) => apiAxios('post', baseURL + '/wms.stock.toDiscardApply', data),
  // 库存-清理
  toClear: (data) => apiAxios('post', baseURL + '/wms.stock.toClear', data),

  // 货架-打开库位界面
  wmsGridPreview: (data) => apiAxios('post', baseURL + '/wms.wmsGridPreview', data),
  // 库存-查看指定库位商品
  gridStockDetail: (data) => apiAxios('post', baseURL + '/wms.stock.gridStockDetail', data),

  // 库存-申请废弃列表
  toDiscardList: (data) => apiAxios('post', baseURL + '/wms.stock.toDiscardList', data),
  // 库存-废弃修改
  toDiscardUpdate: (data) => apiAxios('post', baseURL + '/wms.stock.toDiscardUpdate', data),
  // 库存-废弃删除
  toDiscardDelete: (data) => apiAxios('post', baseURL + '/wms.stock.toDiscardDelete', data),
  // 库存-废弃审批
  toDiscardConfirm: (data) => apiAxios('post', baseURL + '/wms.stock.toDiscardConfirm', data),

  // 库存-清理列表
  toClearList: (data) => apiAxios('post', baseURL + '/wms.stock.toClearList', data),

  // 库存-移库
  stockMove: (data) => apiAxios('post', baseURL + '/wms.stock.stockMove', data),

  // 库存-商品标记-配置-列表
  labelConfigList: (data) => apiAxios('post', baseURL + '/wms.stock.label.labelConfigList', data),
  // 库存-商品标记-配置-列表
  labelStore: (data) => apiAxios('post', baseURL + '/wms.stock.label.store', data),
  // 库存-商品标记-配置-修改
  labelUpdate: (data) => apiAxios('post', baseURL + '/wms.stock.label.update', data),
  // 库存-商品标记-配置-删除
  labelDelete: (data) => apiAxios('post', baseURL + '/wms.stock.label.delete', data),
  // 库存-商品标记-配置-已标记商品数
  labelGoodsCount: (data) => apiAxios('post', baseURL + '/wms.stock.label.labelGoodsCount', data),
  // 库存-商品标记-配置-批量打标
  batchSetLabel: (data) => apiAxios('post', baseURL + '/wms.stock.label.batchSetLabel', data),

  // 备品仓库-设置处理备注
  discardDealRemarkSet: (data) => apiAxios('post', baseURL + '/wmsStock.discard.discardDealRemarkSet', data),
  // 备品仓库-设置处理类型
  discardDealTypeSet: (data) => apiAxios('post', baseURL + '/wmsStock.discard.discardDealTypeSet', data),


  /* 辅料 */
  // 解绑消耗辅料
  sortingUnbindMaterial: (data) => apiAxios('post', baseURL + '/admin/material/material/sortingUnbindMaterial', data),
  // 辅料类别-列表
  materialTypeList: (data) => apiAxios('post', baseURL + '/admin/material/type/list', data),
  // 辅料类别-保存
  materialTypeBatchSave: (data) => apiAxios('post', baseURL + '/admin/material/type/batchSave', data),
  // 创建辅料
  materialStore: (data) => apiAxios('post', baseURL + '/admin/material/material/store', data),
  // 辅料-列表
  materialList: (data) => apiAxios('post', baseURL + '/admin/material/material/list', data),
  // 辅料-删除
  materialDelete: (data) => apiAxios('post', baseURL + '/admin/material/material/delete', data),
  // 辅料-修改
  materialUpdate: (data) => apiAxios('post', baseURL + '/admin/material/material/update', data),
  // 辅料-单独修改名称
  updateName: (data) => apiAxios('post', baseURL + '/admin/material/material/updateName', data),
  // 辅料-单独修改注意事项
  updateNotice: (data) => apiAxios('post', baseURL + '/admin/material/material/updateNotice', data),
  // 辅料-单独修改主图
  updateMainImage: (data) => apiAxios('post', baseURL + '/admin/material/material/updateMainImage', data),
  // 辅料-单独修改详情图
  updateImages: (data) => apiAxios('post', baseURL + '/admin/material/material/updateImages', data),
  // 辅料-单独修改文件
  updateFiles: (data) => apiAxios('post', baseURL + '/admin/material/material/updateFiles', data),
  // 辅料-详情
  materialDetail: (data) => apiAxios('post', baseURL + '/admin/material/material/detail', data),
  // 辅料实际库位库存，点击查询时传辅料主档 material_id。
  materialStockGrids: (data) => apiAxios('post', baseURL + '/admin/material/material/stockGrids', data, { resolveError: true }),
  // 单辅料配送单消耗/回退历史
  porderUsageLogList: (data) => apiAxios('post', baseURL + '/admin/material/material/porderUsageLogList', data),
  // 辅料标识的订单详情列表
  signOrderDetailList: (data) => apiAxios('post', baseURL + '/admin/material/material/signOrderDetailList', data),
  // 辅料绑定的订单详情列表
  bindOrderDetailList: (data) => apiAxios('post', baseURL + '/admin/material/material/bindOrderDetailList', data),
  // 辅料绑定的商品管理番号及下单方案列表
  boundOrderPlanList: (data) => apiAxios('post', baseURL + '/admin/material/material/boundOrderPlanList', data),
  // 辅料批量绑定候选列表：按管理番号分页并支持方案标签号、业务备注筛选
  orderPlanBindCandidateList: (data) => apiAxios('post', baseURL + '/admin/material/material/orderPlanBindCandidateList', data),
  // 辅料批量绑定到下单方案
  batchBindOrderPlan: (data) => apiAxios('post', baseURL + '/admin/material/material/batchBindOrderPlan', data),
  // 辅料-商详标识为辅料
  sortingSignMaterial: (data) => apiAxios('post', baseURL + '/admin/material/material/sortingSignMaterial', data),
  // 辅料-商详单独设置辅料消耗
  sortingBindMaterial: (data) => apiAxios('post', baseURL + '/admin/material/material/sortingBindMaterial', data),
  // 辅料-商详取消标识为辅料
  sortingNotSignMaterial: (data) => apiAxios('post', baseURL + '/admin/material/material/sortingNotSignMaterial', data),


  // 仓储仓库箱子列表
  chargeStorageList: (data) => apiAxios('post', baseURL + '/wms.chargeStorage.boxList', data),
  // 仓储仓库-批量回退箱子到普通库位
  batchMoveBackToNormal: (data) => apiAxios('post', baseURL + '/wms.chargeStorage.batchMoveBackToNormal', data),
  // 仓储仓库-仓储仓库箱子提出到配送单
  toPorder: (data) => apiAxios('post', baseURL + '/wms.chargeStorage.toPorder', data),

  // 常规仓库-库存直接装箱预览
  fromStockPreview: (data) => apiAxios('post', baseURL + '/box.fromStockPreview', data),
  // 常规仓库-库存直接装箱
  packFromStock: (data) => apiAxios('post', baseURL + '/box.packFromStock', data),


}
